export {
  background,
  border,
  borderRadius,
  boxShadow,
  display,
  flexbox,
  fontSize,
  grid,
  layout,
  opacity,
  overflow,
  position,
  size,
  space,
  typography,
  variant,
  zIndex,
} from 'styled-system'
export { mergeStyles } from './merge-styles'

export type {
  BackgroundProps,
  BorderProps,
  BorderRadiusProps,
  BoxShadowProps,
  DisplayProps,
  FlexboxProps,
  FontSizeProps,
  GridProps,
  LayoutProps,
  OpacityProps,
  OverflowProps,
  PositionProps,
  SizeProps,
  SpaceProps,
  TypographyProps,
  ZIndexProps,
} from 'styled-system'

export type ColorProps = {
  color?: string
}

export const color = (props: ColorProps) =>
  props.color ? { color: props.color } : {}
